export const PoemRacehorse = () => {
    return (
        <div id="044" className="">
            <p>spiked inside, spiked outside,</p>
            <p>it only makes sense to act like the things around you,</p>
            <p>a map drawn in the dark,</p>
            <p>cried out echolocation,</p>
            <p>sometimes it feels like i might only be a thing to be found</p>
            <p>rather than the one searching.</p>
            <p>when exactly do you stop being someone and start</p>
            <p>being something instead?</p>
            <p>the body gets used to anything thrown at it</p>
            <p>day in and day out.</p>
            <br />
            <p>"nothing in a vacuum"</p>
            <p>i think and i say,</p>
            <p>while i try to push everyone off the edge,</p>
            <p>we may meet in the middle,</p>
            <p>but only if it's a place neither of us has run away from yet.</p>
            <p>everything risks becoming a pattern,</p>
            <p>and everything wants to repeat itself,</p>
            <p>even the flames that burned down half of the house</p>
            <p>
                sometimes come back, knock on the door, and ring the doorbell,
            </p>
            <p>i ran from the fire,</p>
            <p>
                pushed the whole planet away with the soles of my feet on the
                ground,
            </p>
            <p>and slowly but surely</p>
            <p>the body gets used to anything thrown at it,</p>
            <p>day in and day out,</p>
            <p>it sheds and it grows,</p>
            <p>the skin and the scales, the fur and the hair,</p>
            <p>the bones, the claws, the tusks,</p>
            <p>and the nails that look like hooves because it thought</p>
            <p>it felt like they needed to</p>
            <p>the next time.</p>
        </div>
    );
};
